<template>
    <div></div>
</template>

<script>
export default {
    name: 'ScrollTracker',
    data() {
        return {
            dispatchedIncrements: [],
            dispatchedSections: [],
        };
    },
    mounted() {
        window.addEventListener('scroll', () => {
            this.trackScrollProgress();
            this.trackSectionVisibility();
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll');
    },
    methods: {
        trackScrollProgress() {
            var documentHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.body.clientHeight,
                document.documentElement.clientHeight,
            );

            var viewportHeight = window.innerHeight;
            var scrollableHeight = documentHeight - viewportHeight;
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            var scrollProgress = (scrollPosition / scrollableHeight) * 100;
            var currentIncrement = Math.floor(scrollProgress / 10) * 10;

            if (this.dispatchedIncrements.indexOf(currentIncrement) === -1) {
                this.dispatchedIncrements.push(currentIncrement);
                window.ipse.dispatch({
                    action: 'page_scrolled',
                    data_event: {
                        scroll_progress: currentIncrement,
                    },
                });
            }
        },
        trackSectionVisibility() {
            var sections = document.querySelectorAll('.track-section');

            sections.forEach((section) => {
                var rect = section.getBoundingClientRect();
                var isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
                let trackName = section.getAttribute('data-track-name');

                if (isVisible && this.dispatchedSections.indexOf(trackName) === -1) {
                    this.dispatchedSections.push(trackName);
                    window.ipse.dispatch({
                        action: 'page_scrolled',
                        data_event: {
                            section_name: trackName,
                        },
                    });
                }
            });
        },
    },
};
</script>
